import React from "react";
import { HiOutlineLibrary } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneMuseum } from "../../../lib/sysNavigation/SysNavigation";

type MuseumRow = {
  museum_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<MuseumRow>
    type={_TYPES_.MUSEUM}
    title="Museums"
    subtitle="Museums featured on the public site."
    icon={<HiOutlineLibrary className="h-5 w-5" />}
    addRoute="/data/museum/add"
    editRoute="/data/museum/edit"
    pushOne={pushOneMuseum}
    dataKey="museums"
    countKey="museumsCount"
    idField="museum_id"
  />
);

export default Overview;
